
export enum EndPoints {
    SignIn = '/session',
    Status = '/app/status',
    LogOut = '/session',
    User = '/user',
    ContactsList = '/user/contacts',
    RecentCalls = '/user/history',
}